module.exports = __webpack_public_path__ + "static/media/team-6.9a03a5a7.avif";